<template>
    <div>
        <div class="row">
            <div class="col-md-4">
                <div class="row">
                    <label class="form-label ml-3 font-weight-700 fs-md color-black">Thông tin lịch test</label>
                </div>
                <div class="card card-custom gutter-b example example-compact border border-gray mb-3">
                    <div class="card-body">
                        <div class="form-row mt-2 mb-3">
                            <div class="col-md-6">
                                <label>Họ và tên khách hàng</label>
                                <el-input type="text" placeholder="Họ tên" v-model="customer.test_input_schedule.name"
                                    disabled />
                            </div>
                            <div class="col-md-6">
                                <label>Số điện thoại khách hàng</label>
                                <el-input type="text" placeholder="Họ tên" v-model="customer.test_input_schedule.phone"
                                    disabled />
                            </div>
                            <div class="col-md-6 mt-2" v-if="statusCreateTestInput == STATUS_SPEAKING_AI">
                                <label>Trung tâm test đầu vào</label>
                                <el-input type="text" placeholder="Họ tên" v-model="customer.center.name" disabled />
                            </div>
                            <div class="col-md-6 mt-2" v-if="statusCreateTestInput == STATUS_SPEAKING_AI">
                                <label>Hình thức test đầu vào</label>
                                <el-input type="text" placeholder="Họ tên" :value="!isPreliminary ? 'Test với AI' : 'Test sơ bộ'"
                                disabled />
                            </div>
                            <div class="col-md-12 mt-2" v-if="isC2Schedule">
                                <label>Giai đoạn học</label>
                                <el-input :value="getGradeLevelLabel(customer.test_input_schedule.grade_level)"
                                    type="text" placeholder="Giai đoạn học" disabled />
                            </div>
                        </div>
                        <test-input :checkExist="true" :testInputSchedule="customer.test_input_schedule"
                            :checkDisable="true" @infoTestInput="handleInfoTestInput"
                            :runCheckSlot="showButtonHuyLichDoiLich"
                            v-if="renderTestInput && !conditionIsOnlyGeneral && statusCreateTestInput != STATUS_SPEAKING_AI"></test-input>
                        <div class="form-row"
                            v-if="conditionIsOnlyGeneral && statusCreateTestInput != STATUS_SPEAKING_AI">
                            <p style="color: red; font-weight: bold; margin-left: 4px">Khách hàng chưa được đặt lịch
                                test
                                speaking!</p>
                            <div class="col-md-12 mb-3">
                                <button type="button" @click="openDialogTestInputSchedule('them-lich-speaking')"
                                    v-if="showButtonDatLichSpeaking"
                                    class="btn btn-success float-left mt-1 ">
                                    <i class="el-icon-date"></i>
                                    <span class="ml-2">Đặt lịch test speaking</span>
                                </button>
                            </div>
                        </div>
                        <div class="form-row" v-else>
                            <!-- Test đầu vào -->
                            <div v-if="!isPreliminary" class="col-md-12 mb-3">
                                <button type="button" @click="openEntranceScheduleDialog()"
                                    class="btn btn-success float-left mt-3 ml-3"
                                    v-if="showButtonDatLai">
                                    <i class="fa fa-undo"></i>
                                    Đặt lại
                                </button>
                                <button type="button" @click="openDialogTestInputSchedule('doi-lich')"
                                    :disabled="loading" class="btn btn-primary float-right mt-3 ml-3"
                                    v-if="showButtonDoiLich"
                                    >
                                    <i class="fa fa-repeat"></i>
                                    Đổi lịch
                                </button>
                                <button type="button" @click="cancelTestInputSchedule"
                                    class="btn btn-danger float-right mt-3 ml-3"
                                    v-if="showButtonHuyLich">
                                    <i class="fal fa-trash mr-1"></i>
                                    Hủy lịch
                                </button>
                            </div>

                            <!-- Test sơ bộ -->
                            <div v-if="isPreliminary" class="col-md-12 mb-3">
                                <button type="button" @click="openPreliminaryDatLai()"
                                    class="btn btn-success float-left mt-3 ml-3"
                                    v-if="showButtonDatLaiSoBo">
                                    <i class="fa fa-undo"></i>
                                    Đặt lại
                                </button>
                                <button type="button" @click="openSkipDialog"
                                    class="btn btn-danger float-left mt-3 ml-3"
                                    v-if="showButtonBoQuaBuocTest">
                                    <i class="fa fa-ban"></i>
                                    Bỏ qua bước test
                                </button>
                                <button type="button"
                                    v-if="showButtonDangKyThi"
                                    class="btn btn-success float-right mt-3 ml-3"
                                    @click="openEntranceScheduleDialog(true)">
                                    <i class="fa fa-repeat"></i>
                                    Đăng ký thi
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="showBaiTestTracNghiem">
                    <div class="row mt-6">
                        <label class="form-label ml-3 font-weight-700 fs-md color-black">{{ conditionIsOnlyGeneral ?
                            'Bài test general' : 'Bài test trắc nghiệm' }}</label>
                    </div>
                    <div class="card card-custom gutter-b example example-compact border border-gray mb-3">
                        <div class="card-body">
                            <p>
                                {{ conditionIsOnlyGeneral 
                                    ? 'Gửi link hoặc quét mã QR tới khách hàng để tiến hành làm bài test general: ' 
                                    : 'Gửi link hoặc quét mã QR cho khách hàng làm bài trước để giúp tiết kiệm thời gian cho buổi kiểm tra đầu vào.' 
                                }}
                            </p>
                            <div class="mb-2">Link website:</div>
                            <div class="form-row">
                                <div class="col-md-10" @click="copyUrl">
                                    <el-input onCopy="return false" disabled placeholder="Please input"
                                        v-model="urlTestInput" id="url"></el-input>
                                </div>
                                <div class="col-md-2" v-if="is_lastest_version">
                                    <el-tooltip content="Sao chép đường dẫn" placement="top">
                                        <button @click="copyUrl" class="btn btn-default ml-1"
                                            title="Sao chép đường dẫn"><i
                                                class="el-icon-document-copy v-size--small"></i></button>
                                    </el-tooltip>
                                </div>
                            </div>
                            <div class="mb-2 mt-3">Mã QR</div>
                            <div style="width: 110px ;height: 110px ; border: solid 1px "
                                class="d-flex justify-content-center align-items-center">
                                <qr-code :text="getUrlCopy" :size="100">
                                </qr-code>
                            </div>
                        </div>
                    </div>
                </div>               
            </div>
            <div class="col-md-8">
                <div class="container mt-xl-0">
                    <div class="row">
                        <label class="form-label ml-3 font-weight-700 fs-md color-black">Trạng thái ca test</label>
                    </div>
                    <div class="row ml-12 mb-4">
                        <label class="status-test-input ml-3 pt-2 pr-4 pb-2 pl-4 badge badge-large badge-primary"
                            style="background-color: #132e4887">{{ customer.status }} </label>
                    </div>
                    <div class="row ml-12 mt-2"
                        v-if="customer?.test_input_schedule?.canceller_name || customer?.test_input_schedule?.reason_cancel">
                        <p class="ml-3" style="color: red;" v-if="customer?.test_input_schedule?.reason_cancel">
                            {{ customer?.test_input_schedule?.reason_cancel }}
                        </p>
                        <p class="ml-3" style="color: red;" v-else>
                            {{ customer.test_input_schedule.canceller_name }} đã hủy lịch test đầu vào lúc
                            {{ formatDate(customer.test_input_schedule.canceled_at) }}
                        </p>
                    </div>
                    <h3 class="form-label font-weight-700 fs-md color-black">Kết quả bài test</h3>

                    <div class="card" style="background-color: #F6F6F6;"
                        v-if="+customer?.test_input_schedule?.center_id !== Cambridge_Mentor_ID">
                        <div class=" content_result  p-4     ">
                            <div v-if="resultTests.length > 0">
                                <h3>Điểm và nhận xét</h3>
                                <div v-for="(resultTest, index) in resultTests" :key="index">
                                    <CommentsTest :total-writing="totalWritingHighBand" :is-high-band="isHighBand"
                                        :writing-high-band="writingHighBand" :resultTest=resultTest :testIELTS="testIELTS
                                            " :isSecondarySchool= "isSecondarySchool"/>
                                </div>
                                <OveralTest
                                    v-if="isShowOverallTest"
                                    :pointOverall="pointOverall" :testIELTS="testIELTS"></OveralTest>
                                <div v-if="suggestedCourse || suggestedCourse != ''">
                                    <h3>Khóa học gợi ý</h3>
                                    <div class="bg-white rounded-sm p-5" style="font-size: 16px">
                                        {{ suggestedCourse }}
                                    </div>
                                </div>
                                <div v-if="supplementalCourse">
                                    <h3>Khóa học bổ sung</h3>
                                    <div class="bg-white rounded-sm p-5" style="font-size: 16px">
                                        {{ supplementalCourse }}
                                    </div>
                                </div>
                            </div>
                            <div v-else>
                                <p class="mb-0" style="font-size: 16px">Chưa có kết quả.</p>
                            </div>
                        </div>
                    </div>

                    <div v-else class="card" style="background-color: #F6F6F6;">
                        <div class=" content_result  p-4     ">
                            <div v-if="resultTests.length > 0">
                                <div class="card p-4 mb-4" v-for="(result, index1) in resultTests" :key="index1">
                                    <ResultTestDetailChild :result="result"></ResultTestDetailChild>
                                </div>
                                <div class="card p-4 mb-4" v-for="(item, index2) in commentAndConclusion" :key="index2">
                                    <comment-and-conclusion :comment="item"></comment-and-conclusion>
                                </div>
                            </div>
                            <div v-else>
                                <p class="mb-0" style="font-size: 16px">Chưa có kết quả.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog :title="dialog.title" class="responsive" :visible.sync="dialogFormVisible"
            :before-close="handleBeforeCloseScheduleDialog" :close-on-click-modal="false"
            :show-close="false" :destroy-on-close="true">
            <ValidationObserver ref="form" v-slot="{ handleSubmit }"
                v-if="showScheduleFormInDialog">
                <form class="form appointment-form" @submit.prevent="handleSubmit(submit)" autocomplete="off">
                    <el-row :gutter="10" class="pr-2 pl-2">
                        <reschedule-test-input v-if="dialogFormVisible" :checkExist="checkExistTestInputSchedule"
                            :testInputSchedule="customer.test_input_schedule" :showTestInput="true"
                            :showLearningFields="true"
                            @infoTestInput="handleInfoTestInput">
                        </reschedule-test-input>
                    </el-row>
                    <p v-if="showAiAttemptLimitWarning" class="px-2 mb-3"
                        style="color: #FF0000; font-style: italic">
                        Do học viên đã hết lần test với AI nên vui lòng đặt lịch test speaking với Admin.
                    </p>
                    <div class="form-row">
                        <div class="col-md-12 mb-3">
                            <button :disabled="disableSubmit" class="btn btn-primary float-right mt-3 ml-3">
                                <i v-if="disableSubmit" class="el-icon-loading"></i>Xác nhận
                            </button>
                            <button type="button" @click="closeDialog" class="btn btn-secondary float-right mt-3 ml-3">
                                Hủy bỏ
                            </button>
                        </div>
                    </div>
                </form>
            </ValidationObserver>
            <div v-else>
                <option-create-test-input v-if="statusCreateTestInput === STATUS_CHOOSE_OPTION"
                    :is-schedule-closed="isScheduleClosed"
                    @cancel="dialogFormVisible = false" @confirmOption="confirmOption"></option-create-test-input>
                <LoadingCreateTestInput v-if="statusCreateTestInput === STATUS_PENDING" :idTaskCreating="idTaskCreating"
                    @statusCreateTestInput="handleStatusCreateTestInput" :count-time="countTime" />
                <cancel-create-input
                    v-if="statusCreateTestInput === STATUS_FAlURE || statusCreateTestInput === STATUS_NOT_ACTIVE"
                    @closeModal="dialogFormVisible = false" />
                <overload-create-test-input v-if="statusCreateTestInput === STATUS_OVER_LOADING"
                    @closeModal="dialogFormVisible = false" />
            </div>
        </el-dialog>
        <div>
            <el-dialog title="Xác nhận khách hàng tham gia test speaking" :visible.sync="confirmSpeaking"
                :width="isMobile() ? '90%' : '30%'" :close-on-click-modal="false" :show-close="false">
                <p>{{ `Khách hàng ${dataConfirmSpeaking.name} có một lịch test speaking với giảng viên vào lúc:` }}</p>
                <p style="color: #5E00B6;font-weight: bold">{{ `Thời gian: ${dataConfirmSpeaking.time}` }}</p>
                <p>Vui lòng xác nhận nếu khách hàng có tham gia hoặc Hủy lịch nếu khách hàng không còn nhu cầu.</p>
                <div class="d-flex justify-content-end" v-if="is_lastest_version">
                    <button type="button" class="btn btn-danger mr-3" @click="confirmTestSpeaking(false)">Hủy
                        lịch</button>
                    <button type="button" class="btn btn-success" @click="confirmTestSpeaking(true)">Khách hàng có tham
                        gia</button>
                </div>
            </el-dialog>
            <el-dialog :title="dialog.title" class="responsive" :visible.sync="checkCreateTestInput"
                :destroy-on-close="true" :close-on-click-modal="false" :show-close="false">
                <option-create-test-input :resetData="checkResetData" :is-create-customer="true"
                    @cancel="checkCreateTestInput = false"
                    @confirmOption="confirmOption" />

            </el-dialog>
        </div>

        <skip-entrance-test-dialog
            :visible.sync="skipDialogVisible"
            :customer-id="customerId || customer.id"
            @skipped="handleSkipped"
        />
        <schedule-entrance-test-dialog
            :visible.sync="scheduleEntranceTestDialogVisible"
            :title="entranceRetakeMode ? 'Đặt lịch thi đầu khóa' : 'Đặt lịch test đầu vào'"
            :retake-center-id="entranceRetakeMode ? customer?.center?.id : null"
            :close-on-confirm="false"
            :confirm-loading="entranceScheduleConfirmLoading"
            @confirm="confirmEntranceSchedule"
        />
        <el-dialog
            v-if="[STATUS_PENDING, STATUS_FAlURE, STATUS_OVER_LOADING].includes(statusCreateTestInput)"
            title="Đặt lịch test đầu vào"
            class="responsive"
            width="570px"
            :visible.sync="openScheduleTestInput"
            :destroy-on-close="true"
            @close="resetEntranceModal"
            :close-on-click-modal="false"
            :show-close="true"
        >
            <el-row :gutter="10" class="pr-2 pl-2">
                <LoadingCreateTestInput v-if="statusCreateTestInput === STATUS_PENDING"
                    :idTaskCreating="idTaskCreating" @statusCreateTestInput="handleStatusCreateTestInput"
                    :countTime="countTime" />
                <cancel-create-input v-if="statusCreateTestInput === STATUS_FAlURE"
                    @closeModal="openScheduleTestInput = false" />
                <overload-create-test-input v-if="statusCreateTestInput === STATUS_OVER_LOADING"
                    @closeModal="openScheduleTestInput = false" />
            </el-row>
        </el-dialog>
    </div>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import TestInput from "@/views/pages/customer/test-input";
import {
    CANCEL_TEST_INPUT_SCHEDULE,
    CREATE_TEST_INPUT_SCHEDULE,
    GET_RESULT_EXAM,
    GET_TEST_INPUT_ENTRACNE,
    UPDATE_TEST_INPUT_SCHEDULE
} from "@/core/services/store/customer/testInput.module";
import moment from 'moment-timezone';
import {
    CHO_CHAM_DIEM,
    DA_DAT_LICH,
    DA_TEST_GENERAL,
    DA_TEST_SPEAKING,
    DA_TRA_KET_QUA,
    HUY_LICH,
    STATUS_CAN_TEST_GEN_LABEL,
    STATUS_CAN_TEST_SPEAKING_LABEL,
    STATUS_CAN_DANG_KY_THI_DAU_KHOA_LABEL,
    STATUS_DA_TEST_SPEAKING_LABEL,
    STATUS_DA_TRA_KET_QUA_SO_BO_LABEL,
    STATUS_DA_DANG_KY_THI_DAU_KHOA_LABEL,
    STATUS_DA_BO_QUA_KIEM_TRA_LABEL
} from "@/core/config/customer/testInputSchedule";
import Swal from "sweetalert2";
import { ECOACH } from "../../../core/config/center/centerOption";
import { ResultTest } from "@/views/pages/customer/models/result_test";
import { TYPE_TEST_BY_KEY } from "@/core/config/testInput/testInputOption";
import CommentsTest from "@/views/pages/customer/components/CommentsTest";
import OveralTest from "@/views/pages/customer/components/OveralTest";
import RescheduleTestInput from "@/views/pages/customer/reschedule-test-input";
import {
    CHECK_STATUS,
    CONFIRM_CUSTOMER_COME_TEST,
    CREATE_TEST_INPUT_SCHEDULE_CUSTOMER,
    IS_TIME_TO_CONFIRM,
    STORE_ONLY_GENERAL,
    STORE_SPEAKING_API,
    SWITCH_SPEAKING_API,
    COUNT_SPEAKING_AI_ATTEMPTS
} from "../../../core/services/store/customer/testInput.module";
import { REGISTER_ENTRANCE_EXAM } from "@/core/services/store/customer/entrance.module";
import CancelCreateInput from "./components/CancelCreateInput.vue";
import LoadingCreateTestInput from "./components/LoadingCreateTestInput.vue";
import OverloadCreateTestInput from "./components/OverloadCreateTestInput.vue";
import {
    STATUS_CHOOSE_OPTION,
    STATUS_CREATE,
    STATUS_FAlURE,
    STATUS_NOT_ACTIVE,
    STATUS_OVER_LOADING,
    STATUS_PENDING,
    STATUS_TO_DO,
    TYPE_SPEAKING_AI,
    Mentor_English_Mastery_ID,
} from "../../../core/config/testInput/testInputOption";
import {
    buildLearningSchedulePayload,
    getGradeLevelLabel
} from "@/core/config/testInput/learningOption";
import {
    buildScheduleBandPayload
} from "@/core/config/testInput/scheduleFieldOption";
import {
    ERROR_CODE_ASSIGN_FORM_EDIT,
    ERROR_CODE_UPDATE_IN_TASK_CANCEL
} from "../../../core/config/testInput/errorCodeDefine";
import ResultTestDetailChild from "./components/ResultTestDetailChild.vue";
import CommentAndConclusion from "./components/CommentAndConclusion.vue";
import { mapGetters } from "vuex";
import OptionCreateTestInput from "./components/OptionCreateTestInput";
import ScheduleEntranceTestDialog from "./components/ScheduleEntranceTestDialog.vue";
import SkipEntranceTestDialog from "./components/SkipEntranceTestDialog.vue";

export default {
    name: "detail-test-input-entrance",
    components: {
        CommentAndConclusion,
        ResultTestDetailChild,
        OverloadCreateTestInput,
        LoadingCreateTestInput,
        CancelCreateInput,
        RescheduleTestInput, OveralTest, CommentsTest, TestInput,
        OptionCreateTestInput,
        ScheduleEntranceTestDialog,
        SkipEntranceTestDialog
    },
    data() {
        return {
            customer: {
                test_input_schedule: {}
            },
            loading: false,
            showButtonHuyLichDoiLich: false,
            renderTestInput: false,
            testInput: {},
            dialog: {
                title: ''
            },
            dialogFormVisible: false,
            checkExistTestInputSchedule: false,
            urlTestInput: this.getUrlCopy,
            resultTests: [],
            testIELTS: false,
            suggestedCourse: null,
            supplementalCourse: null,
            disableSubmit: false,
            pointOverall: null,
            DA_DAT_LICH: DA_DAT_LICH,
            DA_TEST_GENERAL: DA_TEST_GENERAL,
            DA_TEST_SPEAKING: DA_TEST_SPEAKING,
            CHO_CHAM_DIEM: CHO_CHAM_DIEM,
            DA_TRA_KET_QUA: DA_TRA_KET_QUA,
            HUY_LICH: HUY_LICH,
            STATUS_CAN_TEST_GEN_LABEL,
            STATUS_CAN_TEST_SPEAKING_LABEL,
            STATUS_CAN_DANG_KY_THI_DAU_KHOA_LABEL,
            STATUS_DA_TEST_SPEAKING_LABEL,
            STATUS_DA_TRA_KET_QUA_SO_BO_LABEL,
            STATUS_DA_DANG_KY_THI_DAU_KHOA_LABEL,
            // Normalize number|string từ Vue Router (SPA push giữ Number, F5 parse URL thành String)
            statusCreateTestInput: this.$route.query.status != null && this.$route.query.status !== ''
                ? Number(this.$route.query.status)
                : null,
            idTaskCreating: null,
            createdTestInputScheduleId: null,
            STATUS_TO_DO: STATUS_TO_DO,
            STATUS_PENDING: STATUS_PENDING,
            STATUS_FAlURE: STATUS_FAlURE,
            STATUS_OVER_LOADING: STATUS_OVER_LOADING,
            STATUS_CREATE: STATUS_CREATE,
            idCustomer: null,
            countTime: 60,
            Cambridge_Mentor_ID: 530,
            commentAndConclusion: [],
            status: '',
            confirmSpeaking: false,
            dataConfirmSpeaking: {
                name: '',
                time: ''
            },
            successCreateData: {},
            STATUS_CHOOSE_OPTION: STATUS_CHOOSE_OPTION,
            STATUS_NOT_ACTIVE: STATUS_NOT_ACTIVE,
            STATUS_SPEAKING_AI: TYPE_SPEAKING_AI,
            checkCreateTestInput: false,
            checkResetData: false,
            checkChangeSchedule: false,
            isOnlyGeneral: '',
            isHighBand: false,
            totalWritingHighBand: '',
            writingHighBand: [],
            highBand: 1,
            HighBandSource: 2,
            bandType: 1,
            scheduleEntranceTestDialogVisible: false,
            skipDialogVisible: false,
            entranceRetakeMode: false,
            entranceScheduleConfirmLoading: false,
            openScheduleTestInput: false,
            speakingAiAttempts: 0,
            showAiAttemptLimitWarning: false,
            editingScheduleForm: false,
            isSecondarySchool: false
        }
    },
    mounted() {
        this.setBreadcrumb();
        this.getTestInputSchedule();


    },
    watch: {
        dialogFormVisible() {
            // this.statusCreateTestInput = STATUS_CREATE;
        },
        statusCreateTestInput() {
            this.getTestInputSchedule();
        },
        isPreliminary() {
            this.setBreadcrumb();
        },
        '$route.params.id'(newId, oldId) {
            if (newId && String(newId) !== String(oldId)) {
                this.getTestInputSchedule();
            }
        }
    },
    computed: {
        isShowOverallTest() {
            return this.pointOverall && ((this.testIELTS && this.resultTests.length == 4) || ((!this.testIELTS && this.resultTests.length == 2)));
        },
        is_lastest_version() {
            const q = this.$route.query.is_latest;
            if (q === '1' || q === '0') {
                return q === '1';
            }
            return !!this.customer.is_latest_test_input_schedule;
        },
        showButtonDatLichSpeaking() {
            return this.is_lastest_version;
        },
        showButtonDatLai() {
            if (!this.is_lastest_version) return false;
            const status = this.customer?.test_input_schedule?.status;
            return [DA_TEST_SPEAKING, DA_TRA_KET_QUA, HUY_LICH, CHO_CHAM_DIEM].includes(status)
                || this.statusCreateTestInput == TYPE_SPEAKING_AI;
        },
        showButtonDoiLich() {
            if (!this.is_lastest_version) return false;
            const status = this.customer?.test_input_schedule?.status;
            return [DA_DAT_LICH, DA_TEST_GENERAL].includes(status)
                && !this.untilTestTime
                && this.statusCreateTestInput != TYPE_SPEAKING_AI;
        },
        showButtonHuyLich() {
            return this.showButtonDoiLich;
        },
        showButtonDatLaiSoBo() {
            if (!this.is_lastest_version) return false;
            const status = this.customer?.status;
            return [STATUS_CAN_TEST_GEN_LABEL, STATUS_CAN_TEST_SPEAKING_LABEL, STATUS_DA_TEST_SPEAKING_LABEL,
                STATUS_DA_TRA_KET_QUA_SO_BO_LABEL, STATUS_DA_BO_QUA_KIEM_TRA_LABEL].includes(status)
        },
        showButtonBoQuaBuocTest() {
            return this.is_lastest_version
                && [STATUS_CAN_TEST_GEN_LABEL, STATUS_CAN_TEST_SPEAKING_LABEL, STATUS_CAN_DANG_KY_THI_DAU_KHOA_LABEL]
                    .includes(this.customer?.status);
        },
        showButtonDangKyThi() {
            return this.is_lastest_version
                && [STATUS_CAN_DANG_KY_THI_DAU_KHOA_LABEL].includes(this.customer.status);
        },
        isPreliminary(){
            return this.customer.is_preliminary_test
        },
        customerId() {
            return this.$route.query.customer_id;
        },
        breadcrumbTitle() {
            return this.isPreliminary ? "Chi tiết ca test sơ bộ" : "Chi tiết ca test đầu vào";
        },
        getUrlCopy() {
            if (this.customer.test_input_schedule.center_id === ECOACH) {
                return process.env.VUE_APP_TEST_INPUT_ECOACH + 'login?token=' + this.customer.test_input_schedule.uuid;
            }
            return process.env.VUE_APP_TEST_INPUT_IELTS + 'login?token=' + this.customer.test_input_schedule.uuid;
        },
        customerInfoCopy() {
            return `Đường liên kết tới bài kiểm tra đầu vào của khách hàng ${this.customer.test_input_schedule.name} - ${this.customer.test_input_schedule.phone} `;
        },
        // Lịch hiện tại đã đóng (Đã trả kết quả / Hủy lịch) → mọi lựa chọn đều là đặt lại mới.
        // Dùng để bỏ qua guard chặn Speaking-AI vốn dựa trên query param status còn sót giá trị cũ.
        isScheduleClosed() {
            return [DA_TRA_KET_QUA, HUY_LICH].includes(+this.customer?.test_input_schedule?.status);
        },
        showBaiTestTracNghiem() {
            return !(+this.customer.test_input_schedule.status === HUY_LICH)
        },
        conditionIsOnlyGeneral() {
            return this.status === 'Đăng ký test general' || !this.customer?.test_input_schedule?.branch_id;
        },
        untilTestTime() {
            const now = moment().format('yyyy-MM-DD HH:mm');
            const startTest = moment(this.customer?.test_input_schedule?.schedule).format('yyyy-MM-DD HH:mm');
            return now > startTest;
        },
        isC2Schedule() {
            const gradeLevel = this.customer?.test_input_schedule?.grade_level;
            const hasGradeLevel = gradeLevel !== null && gradeLevel !== undefined && gradeLevel !== '';

            // Bản ghi Cấp 2 lưu grade_level để hiển thị Giai đoạn học.
            // Giữ fallback band_type = 2 cho dữ liệu cũ nếu backend trả theo loại đề.
            return hasGradeLevel || Number(this.customer?.test_input_schedule?.band_type) === 2;
        },
        // Hiện form đặt/đổi lịch trong dialog mà không ghi đè statusCreateTestInput
        showScheduleFormInDialog() {
            // Đổi lịch / mở form tường minh: luôn hiện form (không bị status=7 CHOOSE_OPTION chặn)
            if (this.editingScheduleForm) {
                return true;
            }
            const resultStates = [
                STATUS_PENDING,
                STATUS_TO_DO,
                STATUS_FAlURE,
                STATUS_NOT_ACTIVE,
                STATUS_OVER_LOADING,
                STATUS_CHOOSE_OPTION
            ];
            const status = this.statusCreateTestInput != null && this.statusCreateTestInput !== ''
                ? Number(this.statusCreateTestInput)
                : this.statusCreateTestInput;
            if (resultStates.includes(status)) {
                return false;
            }
            return status === STATUS_CREATE
                || status == TYPE_SPEAKING_AI;
        },
        ...mapGetters([
            'isPilot'
        ])
    },
    methods: {
        async getResultTests() {
            let test_input_schedule_id = this.customer.test_input_schedule.id
            let data = await this.$store.dispatch(GET_RESULT_EXAM, test_input_schedule_id ?? 0);
            this.suggestedCourse = data?.data?.course_suggest
            // Khóa học bổ sung chỉ có với phiếu chạy quy định mới; phiếu cũ và phiếu
            // cấp 2 luôn trả null nên khối này tự ẩn.
            this.supplementalCourse = data?.data?.supplemental_course ?? null
            if (!data.error) {
                this.isSecondarySchool = data?.data?.is_c2??false
                this.isHighBand = +data?.data?.source === this.HighBandSource || +data?.data?.source === this.highBand;
                this.writingHighBand = data.data?.writing && data.data?.writing?.tasks?.length > 0 ? data.data?.writing?.tasks : []
                this.totalWritingHighBand = data?.data?.writing_score && data?.data?.writing_score.toString().length === 1 ? `${data?.data?.writing_score}.0`
                    : data?.data?.writing_score && data?.data?.writing_score.toString().length > 1 ? data?.data?.writing_score : '0'
                if (+this.customer?.test_input_schedule?.center_id !== this.Cambridge_Mentor_ID) {
                    let keys = ["speaking", "writing", "listening", "vocabulary", "reading"];
                    if (this.isPreliminary) {
                        // Test sơ bộ: speaking / vocabulary — có data thì hiện
                        keys = ["speaking", "vocabulary"];
                    } else if (this.isSecondarySchool) {
                        keys = ["speaking", "writing", "listening", "reading",'phonetics'];
                        this.testIELTS = true
                    } else if (this.isHighBand) {
                        keys = ["speaking", "writing", "listening", "reading"];
                        this.testIELTS = true
                    } else {
                        keys = ["speaking", "vocabulary"];
                    }
                    this.resultTests = keys.map((obj) => {
                        if (!data?.data?.hasOwnProperty(obj) || data.data[obj] == null) {
                            return null;
                        }
                        return new ResultTest(TYPE_TEST_BY_KEY.get(obj), data.data[obj].right_answers ?? null, data.data[obj].total_correct ?? null, data.data[obj].avg_point ?? null, data.data[obj], data?.data,this.isSecondarySchool);
                    }).filter(d => d != null);
                    console.log(this.resultTests,'this.resultTests')
                    this.pointOverall = data?.data?.overall
                } else {
                    this.resultTests = data?.data?.speaking.filter((e) => e.id != null);
                    this.commentAndConclusion = data?.data?.speaking.filter((e) => e.id == null);
                }

            }
        },
        getGradeLevelLabel,
        setBreadcrumb() {
            this.$store.dispatch(SET_BREADCRUMB, [
                { title: "Danh sách khách hàng", route: "customer-list" },
                { title: this.breadcrumbTitle, icon: 'fas fa-book' }
            ]);
        },
        getTestInputSchedule() {
            this.$store.dispatch(GET_TEST_INPUT_ENTRACNE, this.$route.params.id).then((data) => {
                this.customer = data.data;
                this.setBreadcrumb();
                if (this.is_lastest_version && this.statusCreateTestInput != TYPE_SPEAKING_AI) {
                    this.checkConfirmSpeaking()
                }
                this.status = data?.data?.status
                this.getResultTests()
                if (this.customer.test_input_schedule) {
                    this.showButtonHuyLichDoiLich = !(moment(this.customer.test_input_schedule.schedule).format('YYYY-MM-DD HH:mm:ss') < moment().format('YYYY-MM-DD HH:mm:ss') ||
                        this.customer.test_input_schedule.status == HUY_LICH);
                    this.urlTestInput = this.getUrlCopy;
                }
                if (!this.customer.test_input_schedule) {
                    this.customer.test_input_schedule.name = '';
                    this.customer.test_input_schedule.phone = '';
                }
                this.renderTestInput = true

            });
        },
        cancelTestInputSchedule() {
            Swal.fire({
                title: 'Bạn có chắc chắn muốn hủy lịch kiểm tra đầu vào?',
                text: "",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Xác nhận',
                showLoaderOnConfirm: true,
                cancelButtonText: 'Hủy',
                preConfirm: () => this.checkStatus().then((canProceed) => {
                    if (!canProceed) {
                        return false;
                    }
                    return true;
                })
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store.dispatch(CANCEL_TEST_INPUT_SCHEDULE, this.customer.test_input_schedule_id).then((res) => {
                        if (res.error) {
                            this.$message({ type: 'error', message: res.error, showClose: true });
                        } else {
                            this.checkExistTestInputSchedule = true
                            this.getTestInputSchedule()
                            this.$message({ type: 'success', message: `Hủy lịch test đầu vào thành công`, showClose: true });
                        }
                    }).catch((res) => {
                        this.$message({ type: 'success', message: res, showClose: true });
                    });
                }
            });
        },
        openDialogTestInputSchedule(type) {
            if (type === 'doi-lich') {
                this.dialog.title = "Đổi lịch test đầu vào";
                this.checkExistTestInputSchedule = true;
                this.checkChangeSchedule = true;
                this.checkStatus().then(canOpen => {
                    if (!canOpen) {
                        return;
                    }
                    this.checkCreateTestInput = false;
                    this.editingScheduleForm = true;
                    this.dialogFormVisible = true;
                });
                return;
            }
            if (type === 'them-lich-speaking') {
                this.dialog.title = "Đặt lịch test đầu vào";
                this.checkResetData = false
            } else if (type === 'dat-lich') {
                this.dialog.title = "Đặt lịch test đầu vào";
                if (this.statusCreateTestInput == TYPE_SPEAKING_AI) {
                    this.checkResetData = false
                }
                this.checkExistTestInputSchedule = false;
            }
            setTimeout(() => {
                this.checkCreateTestInput = true;
            })
        },
        openEntranceScheduleDialog(isRetake = false) {
            const open = () => {
                this.entranceRetakeMode = isRetake;
                this.scheduleEntranceTestDialogVisible = true;
            };
            // Đăng ký thi: không check status
            if (isRetake) {
                open();
                return;
            }
            this.checkStatus().then((canOpen) => {
                if (!canOpen) {
                    return;
                }
                open();
            });
        },
        openSkipDialog() {
            this.checkStatus().then((canOpen) => {
                if (canOpen) {
                    this.skipDialogVisible = true;
                }
            });
        },
        handleSkipped() {
            this.$set(this.customer, 'status', STATUS_DA_BO_QUA_KIEM_TRA_LABEL);
        },
        openPreliminaryDatLai() {
            this.speakingAiAttempts = 0;
            const openDialog = () => this.openEntranceScheduleDialog(false);
            if (!this.customerId) {
                openDialog();
                return;
            }
            this.$store.dispatch(COUNT_SPEAKING_AI_ATTEMPTS, this.customerId)
                .then((data) => {
                    this.speakingAiAttempts = Number(data?.data ?? 0) || 0;
                })
                .catch(() => {
                    this.speakingAiAttempts = 0;
                })
                .finally(openDialog);
        },
        openAdminScheduleAfterAiLimit() {
            this.dialog.title = "Đặt lịch test đầu vào";
            this.checkExistTestInputSchedule = false;
            this.checkChangeSchedule = false;
            this.checkCreateTestInput = false;
            this.showAiAttemptLimitWarning = true;
            this.editingScheduleForm = true;
            this.dialogFormVisible = true;
        },
        async confirmEntranceSchedule(payload = {}) {
            this.entranceScheduleConfirmLoading = true;
            try {
                // Đăng ký thi (retakeMode): bỏ check status; Đặt lại vẫn check
                if (!this.entranceRetakeMode) {
                    const canProceed = await this.checkStatus();
                    if (!canProceed) {
                        return;
                    }
                }
                if (payload.type === 'basic') {
                    if (this.isPreliminary && this.speakingAiAttempts >= 4) {
                        this.closeEntranceScheduleDialog();
                        this.openAdminScheduleAfterAiLimit();
                        return;
                    }
                    await this.createSpeakingAiEntranceSchedule(payload.center_id);
                    return;
                }
                if (payload.type === 'higher') {
                    await this.registerEntranceExamSchedule(payload);
                    return;
                }
                if (payload.type === 'mastery') {
                    await this.createMasteryEntranceSchedule(payload);
                }
            } finally {
                this.entranceScheduleConfirmLoading = false;
            }
        },
        closeEntranceScheduleDialog() {
            this.scheduleEntranceTestDialogVisible = false;
            this.entranceScheduleConfirmLoading = false;
        },
        createSpeakingAiEntranceSchedule(centerId) {
            if (!this.customerId) {
                this.$message({
                    type: 'warning',
                    message: 'Không tìm thấy thông tin khách hàng để đặt lịch. Vui lòng thử lại.',
                    showClose: true
                });
                return Promise.resolve();
            }
            const payload = {
                name: this.customer?.test_input_schedule?.name,
                phone: this.customer?.test_input_schedule?.phone,
                customer_id: this.customerId,
                center_id: centerId
            };
            this.statusCreateTestInput = TYPE_SPEAKING_AI;
            return this.$store.dispatch(STORE_SPEAKING_API, payload).then((data) => {
                console.log(data,'data111111111111');
                
                if (!data.data) {
                    this.$message({
                        message: 'Bạn đã chọn nhu cầu test đầu vào này trước đó. Vui lòng chọn hình thức khác.',
                        type: 'warning'
                    });
                    return;
                }
                const testInputScheduleId = data?.data?.id;
                if (!testInputScheduleId || data?.error) {
                    return;
                }
                this.$message({
                    type: 'success',
                    message: 'Đặt lịch thành công',
                    showClose: true
                });
                this.closeEntranceScheduleDialog();
                const query = {
                    status: this.statusCreateTestInput,
                    customer_id: this.customerId,
                    is_latest: '1'
                };
                this.$router.replace({
                    name: 'customer-test-input-entrance',
                    params: { id: testInputScheduleId },
                    query
                });
            }).catch((error) => {
                this.$message({
                    type: 'error',
                    message: error?.data?.message ?? 'Đặt lịch Speaking AI thất bại',
                    showClose: true
                });
            });
        },
        registerEntranceExamSchedule({ center_id, marking_exam_shift_id }) {
            if (!this.customer?.user_id) {
                this.$message({
                    type: 'warning',
                    message: 'Không tìm thấy thông tin học viên để đăng ký lịch thi. Vui lòng thử lại.',
                    showClose: true
                });
                return Promise.resolve();
            }
            return this.$store.dispatch(REGISTER_ENTRANCE_EXAM, {
                user_id: this.customer.user_id,
                center_id: center_id,
                marking_exam_shift_id: Number(marking_exam_shift_id)
            }).then((res) => {
                this.$message({
                    type: res?.error ? 'warning' : 'success',
                    message: res?.message || 'Đăng ký lịch thi đầu khóa thành công',
                    showClose: true
                });
                if (res?.error) {
                    return;
                }
                this.closeEntranceScheduleDialog();
                const retakeId = res?.data?.id;
                if (!retakeId) {
                    this.getTestInputSchedule();
                    return;
                }
                const query = { is_latest: '1' };
                if (this.customerId) query.customer_id = this.customerId;
                this.$router.replace({
                    name: 'customer-entrance-exam-schedule',
                    params: { marking_exam_retake_id: retakeId },
                    query
                });
            }).catch((error) => {
                this.$message({
                    type: 'error',
                    message: error?.data?.message ?? 'Đăng ký lịch thi đầu khóa thất bại',
                    showClose: true
                });
            });
        },
        createMasteryEntranceSchedule({ testInput }) {
            if (!this.customerId) {
                this.$message({
                    type: 'warning',
                    message: 'Không tìm thấy thông tin khách hàng để đặt lịch. Vui lòng thử lại.',
                    showClose: true
                });
                return Promise.resolve();
            }
            const payload = buildScheduleBandPayload({
                payload: { ...testInput, customer_id: this.customerId },
                bandType: 1,
                masteryCenterId: Mentor_English_Mastery_ID
            });
            return this.$store.dispatch(CREATE_TEST_INPUT_SCHEDULE_CUSTOMER, payload).then((data) => {
                this.$message({
                    type: 'success',
                    message: 'Đặt lịch thành công',
                    showClose: true
                });
                this.closeEntranceScheduleDialog();
                this.idCustomer = this.customerId;
                this.idTaskCreating = data?.data?.id;
                this.createdTestInputScheduleId = data?.data?.test_input_schedule_id;
                this.statusCreateTestInput = STATUS_PENDING;
                this.openScheduleTestInput = true;
            }).catch((error) => {
                this.$message({
                    type: 'error',
                    message: error?.data?.message ?? 'Đặt lịch test đầu vào thất bại',
                    showClose: true
                });
            });
        },
        resetEntranceModal() {
            const q = this.$route.query.status;
            this.statusCreateTestInput = q != null && q !== '' ? Number(q) : null;
            this.idTaskCreating = null;
            this.createdTestInputScheduleId = null;
            this.countTime = 60;
        },
        checkStatus() {
            const id = this.customer?.test_input_schedule?.test_input_schedule_id;
            if (!id) {
                this.$message.error('Không tìm thấy thông tin lịch test');
                return Promise.resolve(false);
            }
            return this.$store.dispatch(CHECK_STATUS, { id }).then(() => {
                return true;
            }).catch((error) => {
                this.getTestInputSchedule();
                this.dialogFormVisible = false;
                this.scheduleEntranceTestDialogVisible = false;
                this.checkCreateTestInput = false;
                this.editingScheduleForm = false;
                if (error && error.data) {
                    this.$message.error(error.data.message);
                }
                return false;
            });
        },
        handleErrorCode(errorCode) {
            if (errorCode === ERROR_CODE_ASSIGN_FORM_EDIT) {
                this.testInput.ngay_hen = null;
                this.testInput.time = null;
            }
            if (errorCode === ERROR_CODE_UPDATE_IN_TASK_CANCEL) {
                this.closeDialog();
            }
        },
        async submit() {
            this.disableSubmit = true;
            const canProceed = await this.checkStatus();
            if (!canProceed) {
                this.disableSubmit = false;
                return;
            }
            this.renderTestInput = false
            this.testInput = _.merge(this.testInput, { id: this.customer.test_input_schedule_id })
            this.testInput.sub_type = this.isOnlyGeneral;
            if (this.checkExistTestInputSchedule || this.conditionIsOnlyGeneral) {
                const payload = buildLearningSchedulePayload({
                    payload: this.testInput,
                    bandType: this.bandType,
                    masteryCenterId: Mentor_English_Mastery_ID
                });
                console.log(payload, "UPDATE_TEST_INPUT_SCHEDULE");
                this.$store.dispatch(UPDATE_TEST_INPUT_SCHEDULE, payload).then((res) => {
                    if (res.error) {
                        this.$message({ type: 'error', message: res.data.message, showClose: true });
                        if (res.data.error_code === 1) {
                            this.testInput.ngay_hen = null;
                            this.testInput.time = null;
                        }
                    } else {
                        this.statusCreateTestInput = STATUS_PENDING;
                        this.updateTimeleft(res?.data?.created_at);
                        // id: task poll GET_SPEAKING | test_input_schedule_id: màn chi tiết
                        this.idTaskCreating = res?.data?.id;
                        this.createdTestInputScheduleId = res?.data?.test_input_schedule_id;
                        this.editingScheduleForm = false;
                        const scheduleId = this.createdTestInputScheduleId || res?.data?.id;
                        this.$router.replace({
                            name: 'customer-test-input-entrance',
                            params: { id: scheduleId },
                            query: {
                                status: this.statusCreateTestInput,
                                is_latest: '1',
                                ...(this.customerId ? { customer_id: this.customerId } : {})
                            }
                        });
                    }
                }).catch((res) => {
                    this.$message({ type: 'error', message: res.data.message, showClose: true });
                    this.getTestInputSchedule();
                    let errorCode = res.data.error_code;
                    this.handleErrorCode(errorCode)
                }).finally(() => {
                    setTimeout(() => {
                        this.disableSubmit = false;
                    }, 2000);
                });
            } else {
                const payload = buildLearningSchedulePayload({
                    payload: this.testInput,
                    bandType: this.bandType,
                    masteryCenterId: Mentor_English_Mastery_ID
                });

                console.log(payload, "CREATE_TEST_INPUT_SCHEDULE");
                this.$store.dispatch(CREATE_TEST_INPUT_SCHEDULE, payload).then((res) => {
                    if (res.error) {
                        this.$message({ type: 'error', message: res.error, showClose: true });
                    } else {
                        this.statusCreateTestInput = STATUS_PENDING;
                        this.idTaskCreating = res?.data?.id;
                        this.createdTestInputScheduleId = res?.data?.test_input_schedule_id;
                        this.editingScheduleForm = false;
                        const scheduleId = this.createdTestInputScheduleId || res?.data?.id;
                        this.$router.replace({
                            name: 'customer-test-input-entrance',
                            params: { id: scheduleId },
                            query: {
                                status: this.statusCreateTestInput,
                                is_latest: '1',
                                ...(this.customerId ? { customer_id: this.customerId } : {})
                            }
                        });
                    }
                }).catch((res) => {
                    this.$message({ type: 'error', message: res.data.message, showClose: true });
                    if (res.data.error_code === 1) {
                        this.testInput.ngay_hen = null;
                        this.testInput.time = null;
                    }
                }).finally(() => {
                    setTimeout(() => {
                        this.disableSubmit = false;
                    }, 2000);
                });
            }
        },
        closeDialog() {
            this.dialogFormVisible = false;
            this.showAiAttemptLimitWarning = false;
            this.editingScheduleForm = false;
        },
        handleBeforeCloseScheduleDialog(done) {
            this.showAiAttemptLimitWarning = false;
            this.editingScheduleForm = false;
        },
        handleInfoTestInput(item) {
            this.testInput = item
        },
        copyUrl() {
            if (!this.is_lastest_version) return;
            // Get the text field
            var copyText = document.getElementById("url");
            // Select the text field
            // copyText.select();
            // copyText.setSelectionRange(0, 99999); // For mobile devices
            // Copy the text inside the text field
            navigator.clipboard.writeText(this.customerInfoCopy + '\n' + copyText.value);
            // Alert the copied text
            this.$message.success("Sao chép đường dẫn thành công");
        },
        handleStatusCreateTestInput(status, customerId, successCreateData) {
            this.idCustomer = customerId;
            this.successCreateData = successCreateData;

            // Đã ở màn detail: poll xong thì đóng dialog + replace/reload ca mới, không hiện popup success
            if (+status === STATUS_TO_DO) {
                const scheduleId = this.createdTestInputScheduleId
                    || successCreateData?.test_input_schedule_id
                    || successCreateData?.test_input_schedule?.id
                    || this.$route.params.id;
                const query = { is_latest: '1' };
                const customerIdQuery = this.customerId || customerId;
                if (customerIdQuery) query.customer_id = customerIdQuery;

                this.dialogFormVisible = false;
                this.openScheduleTestInput = false;
                this.editingScheduleForm = false;
                this.showAiAttemptLimitWarning = false;
                this.statusCreateTestInput = null;
                this.idTaskCreating = null;
                this.createdTestInputScheduleId = null;

                this.$message({
                    type: 'success',
                    message: 'Đặt lịch thành công',
                    showClose: true
                });

                this.$router.replace({
                    name: 'customer-test-input-entrance',
                    params: { id: scheduleId },
                    query
                }).then(() => {
                    this.getTestInputSchedule();
                });
                return;
            }

            this.statusCreateTestInput = status;
        },
        updateTimeleft(created_at) {
            const secondTimeCreate = (new Date(created_at).getTime()) / 1000;
            const secondCurrent = (new Date().getTime()) / 1000;
            const timeRemaining = 60 - (secondCurrent - secondTimeCreate)
            if (timeRemaining > 0) {
                this.countTime = Math.max(timeRemaining, 60);
            }
        },
        formatDate(value) {
            return moment(value).format('HH:mm DD/MM/YYYY')
        },
        checkConfirmSpeaking() {
            let payload = {
                idTaskParent: this.customer?.test_input_schedule_id
            }
            this.$store.dispatch(IS_TIME_TO_CONFIRM, payload).then((data) => {
                // Đã xác nhận xong, API vẫn trả 200 nhưng không còn lịch cần xác nhận
                if (!data?.data?.date) {
                    this.confirmSpeaking = false;
                    return;
                }
                this.confirmSpeaking = true;
                const date = moment(data.data.date, 'YYYY-MM-DD HH:mm:ss');
                this.dataConfirmSpeaking = {
                    name: data.data.name,
                    time: date.format('HH:mm DD-MM-YYYY')
                }
            }).catch(() => {
                this.confirmSpeaking = false;
            })
        },
        confirmTestSpeaking(isCome) {
            let payload = {
                idTaskParent: this.customer?.test_input_schedule_id,
                isCome: isCome
            }
            this.$store.dispatch(CONFIRM_CUSTOMER_COME_TEST, payload).then((data) => {
                this.confirmSpeaking = false;
                this.getTestInputSchedule();
                if (isCome) {
                    this.$message({
                        message: 'Đã xác nhận thành công',
                        type: 'success'
                    });
                    return;
                }
                this.$message('Đã hủy lịch thành công');
            })
        },
        isMobile() {
            return window.innerWidth <= 768;
        },
        confirmOption(isOnlyGeneral, centerId = undefined, registerType = null, optionPayload = {}) {
            this.isOnlyGeneral = isOnlyGeneral;
            let status = this.$route.query.status;
            if (registerType && isOnlyGeneral !== 2) {
                this.bandType = registerType
            }
            if (this.checkChangeSchedule) {
                this.checkCreateTestInput = false;

                if (isOnlyGeneral) {
                    this.reschedule(centerId);
                    return;
                }
                this.editingScheduleForm = true;
                this.dialogFormVisible = true;
                return;
            }

            if (isOnlyGeneral) {
                this.checkCreateTestInput = false;
                this.dialogFormVisible = false;
                let payload = {
                    name: this.customer?.test_input_schedule?.name,
                    phone: this.customer?.test_input_schedule?.phone,
                    customer_id: this.customer?.id,
                    center_id: centerId,
                    id: this.customer?.test_input_schedule?.test_input_schedule_id,
                    ...optionPayload
                }
                let url = '';
                switch (isOnlyGeneral) {
                    case 1:
                        if (status == TYPE_SPEAKING_AI && !this.isScheduleClosed) {
                            this.$message({
                                message: 'Bạn đã chọn nhu cầu test đầu vào này trước đó. Vui lòng chọn hình thức khác.',
                                type: 'warning'
                            });
                            return;
                        }
                        status = TYPE_SPEAKING_AI;
                        url = STORE_SPEAKING_API;
                        break;
                    case 2:
                        url = STORE_ONLY_GENERAL;
                        break;
                }

                this.$store.dispatch(url, payload).then((data) => {
                    if (data.data) {
                        this.$message({
                            message: 'Thành công',
                            type: 'success'
                        });
                        const testInputScheduleId = data?.data?.id;
                        if (!testInputScheduleId || data?.error) {
                            return;
                        }
                        this.$router.push({ name: 'customer-test-input-schedule', params: { id: testInputScheduleId }, query: { status: status } })
                        this.getTestInputSchedule();
                        return;
                    }
                    this.editingScheduleForm = true;
                    this.dialogFormVisible = true;
                }).catch(({ response }) => {
                    this.dialogFormVisible = false;
                    this.$message({
                        message: 'Bạn đã chọn nhu cầu test đầu vào này trước đó. Vui lòng chọn hình thức khác.',
                        type: 'warning'
                    });
                });
            } else {
                this.checkCreateTestInput = false;
                this.editingScheduleForm = true;
                this.dialogFormVisible = true;
                return;
            }
            this.statusCreateTestInput = TYPE_SPEAKING_AI;
            this.checkExistTestInputSchedule = true;
            this.checkCreateTestInput = false;
        },
        reschedule(centerId) {
            this.$store.dispatch(SWITCH_SPEAKING_API, { id: this.customer?.test_input_schedule?.test_input_schedule_id, center_id: centerId }).then((data) => {
                const testInputScheduleId = data?.data?.id;
                if (!testInputScheduleId || data?.error) {
                    return;
                }
                this.statusCreateTestInput = TYPE_SPEAKING_AI;
                this.$router.push({ name: 'customer-test-input-schedule', params: { id: testInputScheduleId }, query: { status: TYPE_SPEAKING_AI } })
                this.getTestInputSchedule();
                this.checkCreateTestInput = false;
                this.$message({ type: 'success', message: `Đổi lịch test đầu vào thành công`, showClose: true });
            }).catch(({ response }) => {
                this.$message({
                    message: response.message,
                    type: 'warning'
                });
            });
        }
    }
}
</script>

<style>
.el-date-editor.el-input {
    width: 100% !important;
}

.status-test-input {
    font-size: 14px;
}

.swal2-confirm {
    background-color: #472F92 !important;
}

.el-select {
    /*display: inline!important;*/
    /*position: relative;*/
}

.content_result {
    max-height: 750px;
    overflow-y: auto;
    height: fit-content;

}
</style>
